import getLocalEntityState from './getLocalEntityState';
export default function getCurrentRecord(entity) {
    var _a;
    return (_a = getLocalEntityState(entity)) === null || _a === void 0 ? void 0 : _a.currentRecord;
}
